import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  forWhoSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  protectYourItemsSectionContent,
  serviceTipsSectionSectionContent,
  whatDoesShipAndStorageSectionContent,
  whatsNotCoveredSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/shipping-insurance-page'

interface ShippingInsurancePageProps {}

const ShippingInsurancePage: React.FC<ShippingInsurancePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
          w-[324px] h-[218px] 
          md-mn:w-[380px] md-mn:h-[286px] 
          lg-mn:w-[448px] lg-mn:h-[313px] 
          xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[255px] xl-min:!h-[50px] lg-mn:w-[240px] md-mn:w-[246px] w-[238px] h-[44px]'
      />
      <HelperSection
        isBgDark
        {...helperSectionContent}
        className={`
            [&_div.content-container]:!mb-0
            xl-min:[&_div.content-container]:!ml-0
            xl-min:[&_div.content-container]:!pr-0
            lg-mn:[&_div.content-container]:pr-12
            [&_div.content-container_p]:!mb-0
            xl-min:[&_div.content-container]:!w-full
            `}
        imgClassName='xl-min:!w-[514px] xl-min:!h-[323px] md-mn:w-[342px] md-mn:h-[215px] w-[342px] h-[215px]'
      />
      <WhyWeSection
        {...whyWeSectionContent}
        className={`
            [&_article]:bg-transparent
            [&_article]:border-none
            [&_article]:text-center 
            [&_article_div]:self-center
            xl-min:[&>div>div:last-of-type]:!grid-cols-4
            md-mn:[&>div>div:last-of-type]:grid-cols-2
            [&_button]:w-[255px]
            `}
        imgClassName='w-[130px] h-[130px]'
      />
      <HelperSection
        isBgDark
        isInverted
        {...protectYourItemsSectionContent}
        imgClassName='xl-min:!w-[514px] xl-min:!h-[323px] md-mn:w-[342px] md-mn:h-[215px] w-[342px] h-[215px]'
        className={`
            [&_div.content-container]:!mb-0
            xl-min:[&_div.content-container]:!pl-0
            lg-mn:[&_div.content-container]:pl-16
            [&_div.content-container_p]:!mb-0
            xl-min:[&_div.content-container]:!w-full
            xl-min:[&>div>div:last-of-type>div]:!gap-10
            md-mn:[&>div>div:last-of-type>div]:gap-0
            [&>div>div:last-of-type>div]:gap-6
            `}
      />
      <WhyWeSection
        {...whatDoesShipAndStorageSectionContent}
        className={`
        [&_article]:bg-transparent
        xl-min:[&>div>div:last-of-type]:!grid-cols-4
        md-mn:[&>div>div:last-of-type]:grid-cols-2
        `}
        sectionTitleClassName={`
            xl-min:!w-full
            md-mn:w-[655px]
            xl-min:[&_p]:!w-full
            [&_p]:w-[90%]
            `}
      />
      <ServiceTipsSectionSection
        {...serviceTipsSectionSectionContent}
        isBgDark
        className='
        [&>div>div:last-child]:md-mn:grid-cols-2 
        xl-min:[&>div>div:last-child]:!grid-cols-3'
        sectionTitleClassName={`
            xl-min:!w-full
            md-mn:w-[499px]
            xl-min:[&_p]:!w-full
            [&_p]:w-[95%]
            `}
      />
      <HelperSection
        {...whatsNotCoveredSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[492px] md-mn:h-[309px] w-[342px] h-[215px]'
        sectionTitleClassName={`
            xl-min:!w-[609px]
            md-mn:w-[503px]
            md-mn:[&_p]:w-full
            [&_p]:w-[92%]
            `}
        className={`
                [&_ul]:space-y-3
                xl-min:[&>div>div:last-of-type>div]:!flex-row
                [&>div>div:last-of-type>div]:flex-col
            `}
      />
      <ForWhoSection
        isBgDark
        {...forWhoSectionContent}
        className='md-mn:[&>div>div:last-child]:!grid-cols-2 xl-min:[&_article_p]:w-[80%]'
        imgClassName='w-[100px] h-[100px]'
        sectionTitleClassName={`
            xl-min:[&_p]:!w-[90%]
            md-mn:[&_p]:w-full
            xl-min:!w-[667px]
            md-mn:w-[480px]
            [&_p]:w-[90%]
            `}
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        className={`
            xl-min:[&_article_button]:!w-[242px] 
            lg-mn:[&_article_button]:w-[236px] 
            md-mn:[&_article_button]:w-[229px]
            [&_article_button]:w-[280px]
            xl-min:[&_article]:h-[452px]
            md-mn:[&_h3]:w-full
            [&_h3]:w-[90%]
            `}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] md-mn:w-[308px] w-[340px] h-[202px]'
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default ShippingInsurancePage
